<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="#" action="#">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">
                  <img
                    src="static/img/numier-blue-logo.svg"
                    style="width: 250px"
                  />
                </h3>
              </div>
              <div class="card-login">
                <fg-input
                  :label="$t('email')"
                  :placeholder="$t('introduzcaEmail')"
                  type="email"
                  v-model="email"
                >
                </fg-input>
                <fg-input
                  :label="$t('pass')"
                  type="password"
                  :placeholder="$t('introduzcaPass')"
                  v-model="pass"
                >
                </fg-input>
                <fg-input>
                  <div class="form-group">
                    <input
                      type="checkbox"
                      v-model="remember"
                      name="checkRemember"
                      id="checkRemember"
                      style="vertical-align: middle"
                    />
                    <label for="checkRemember" class="checkRemember"
                      ><strong>{{ $t("recordarMisDatos") }}</strong></label
                    >
                  </div>
                </fg-input>

                <div>
                  <small>
                    <span class="fa fa-info-circle"></span>
                    {{
                      $t(
                        "paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros"
                      )
                    }}
                    <a href="mailto:info@numier.com">info@numier.com</a>
                  </small>
                </div>

                <div v-if="errorLogin">
                  <div class="alert alert-danger" role="alert">
                    {{ errorTextLogin }}
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-fill btn-primary btn-round btn-wd"
                  @click.prevent="login"
                >
                  {{ $t("iniciarSesion") }}
                </button>
                <br />
                <div class="forgot">
                  <a
                    href="https://www.numier.com/clientes/recordarPass.php"
                    class="card-category"
                  >
                    {{ $t("haOlvidadoSuContrasena") }}
                  </a>
                </div>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
let p1 = null;
import {
  Checkbox as LCheckbox,
  FadeRenderTransition,
} from "src/components/index";
import AuthLayout from "./AuthLayout.vue";
import Vuex from "vuex";
import Vue from "vue";
export default {
  components: {
    LCheckbox,
    FadeRenderTransition,
    AuthLayout,
  },
  data() {
    return {
      email: "",
      pass: "",
      remember: true,
      errorLogin: false,
      errorTextLogin: "",
    };
  },
  methods: {
    ...Vuex.mapMutations(["changeJwt", "changeUser"]),

    ...Vuex.mapActions([
      "cargarBusiness",
      "cargarTpvs",
      "cargarSectores",
      "cargarSelfi",
    ]),

    login() {
      this.checkInputs();
      if (!this.errorLogin) {
        let vm = this;
        this.axios
          .post(this.$store.getters.apiUrl + "login", {
            email: this.email,
            pass: this.pass,
          })
          .then(function(response) {
            if (response.data.response) {
              vm.$store.dispatch("setJWT", response.data.result);
              vm.changeJwt(response.data.result);
              if (vm.remember) {
                var date = new Date();
                date.setDate(date.getDate() + 21);
                vm.$cookie.set("jwt", response.data.result, {
                  expires: date,
                });
              }
              vm.comprobarIdioma();
              // vm.$store.dispatch('fetchBusiness');
              vm.comprobarSectores();
              // vm.comprobarIsSelfi();
              vm.cargarBusiness();

              Promise.all([p1]).then(() => {
                  vm.$router.push("/");
              });

              vm.getPerfil(response.data.result);
              /* vm.terms();*/
            } else {
              vm.errorLogin = true;
              vm.errorTextLogin = response.data.message;
            }
          })
          .catch(function(error) {
            vm.errorLogin = true;
            vm.errorTextLogin = vm.$t("haHabidoUnErrorAlConectarPruebeDeNuevo");
            console.log(error);
          });
      }
    },
    getPerfil(jwt) {
      var config = {
        params: {
          jwt: jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getPerfilBasico", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.perfil != false) {
              vm.changeUser(response.data.result.perfil);
            }
          }
        });
    },

    //* Sirve para saber si es Selfie o no el usuario
    // comprobarIsSelfi() {
    //   let xJwt = this.$store.getters.jwt;
    //   let vm = this;

    //   const base64Url = xJwt.split(".")[1];
    //   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //   const decodedJWT = decodeURIComponent(
    //     atob(base64)
    //       .split("")
    //       .map(function(c) {
    //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    //       })
    //       .join("")
    //   );

    //   // Parsea el JSON decodificado para obtener un objeto JavaScript porque necesito el bool
    //   const jwtObject = JSON.parse(decodedJWT);

    //   // Accede a la propiedad esSelfi
    //   let esSelfi = jwtObject.esSelfi;

    //   //! TODO: traer el jwt y saber si es true o false
    //   if (esSelfi) {
    //     Vue.$cookies.set("esSelfi", "true", Infinity);
    //     vm.cargarSelfi();
    //   } else {
    //     //BUSCO SI TIENE LA VARIABLE Y LA BORRO SI EXISTE Y SI NO NADA
    //     if (Vue.$cookies.isKey("esSelfi")) {
    //       Vue.$cookies.remove("esSelfi");
    //     }
    //   }
    // },

    comprobarSectores() {
      let vm = this;
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      p1 = this.axios
        .get(this.$store.getters.apiUrl + "general/checkSectores", config)
        .then(function(response) {
          if (response.data.response) {
            //SETEO VARIABLE GLOBAL Y GUARDO EN COOKIE QUE VOY A TRABAJAR CON SECTORES
            if (response.data.result) {
              Vue.$cookies.set("sectores", "true", Infinity);
              vm.cargarSectores();
            } else {
              //BUSCO SI TIENE LA VARIABLE Y LA BORRO SI EXISTE Y SI NO NADA

              if (Vue.$cookies.isKey("sectores")) {
                Vue.$cookies.remove("sectores");
              }
            }
          } else {
            console.error(response.data.message);
          }
        });
    },
    comprobarIdioma() {
      let idiomaUsuario = "";
      let vm = this;
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      const getLang = (url) => {
        if (url.includes("numier.pt")) {
          return "pt";
        }
        return "es";
      };
      //Actualizo el idioma si es necesario
      this.axios
        .get(this.$store.getters.apiUrl + "general/getLanguage", config)
        .then(function(response) {
          if (response.data.response) {
            idiomaUsuario = response.data.result;
            if (
              idiomaUsuario != null &&
              idiomaUsuario != undefined &&
              idiomaUsuario != ""
            ) {
              vm.$i18n.locale = idiomaUsuario;
              Vue.$cookies.set("language", idiomaUsuario, Infinity);
            } else if (getLang(window.location.href).includes("numier.pt")) {
              vm.$i18n.locale = "pt";
              Vue.$cookies.set("language", "pt", Infinity);
            } else {
              vm.$i18n.locale = "es";
              Vue.$cookies.set("language", "es", Infinity);
            }
          } else {
            console.error(response.data.message);
          }
        });
    },
    /*terms() {
                this.checkInputs();
                if (!this.errorLogin) {
                    let vm = this
                    this.axios.post(this.$store.getters.apiUrl + "terms", {
                        email: this.email
                    }).then(function (response) {
                        if (response.data.response) {

                            if (response.data.result == 0) {
                                vm.$router.push("/terms");
                            } else {
                                vm.$router.push("/");
                            }
                        } else {
                            this.errorLogin = true;
                            this.errorTextLogin = response.data.message;
                        }
                    }).catch(function (error) {
                        vm.errorLogin = true;
                        vm.errorTextLogin = "Ha habido un error al conectar. Pruebe de nuevo";
                        console.log(error);
                    });
                }
            },*/
    checkInputs() {
      if (this.email == "") {
        this.errorLogin = true;
        this.errorTextLogin = this.$t("elEmailNoPuedeEstarEnBlanco");
        return;
      }

      if (!this.validateEmail(this.email)) {
        this.errorLogin = true;
        this.errorTextLogin = this.$t("elEmailNoEsValido");
        return;
      }

      if (this.pass == "") {
        this.errorLogin = true;
        this.errorTextLogin = this.$t("laContrasenaNoPuedeEstarEnBlanco");
        return;
      }

      this.errorLogin = false;
      this.errorTextLogin = "";
    },
    validateEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.card-login {
  padding: 10px 20px;
}

.checkRemember {
  cursor: pointer;
}

@media (max-width: 768px) {
  .form-group {
    margin-bottom: 0px;
  }

  .card {
    padding-top: 10px;
  }

  img {
    width: 200px;
  }

  .content {
    padding-top: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/GeneralViews/Login.vue